import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DayPromo, getTodayPromo } from '../data/weeklyPromos';
import './PromoModal.css';

interface PromoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PromoModal: React.FC<PromoModalProps> = ({ isOpen, onClose }) => {
  const [promo, setPromo] = useState<DayPromo | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setPromo(getTodayPromo());
    }
  }, [isOpen]);

  if (!isOpen || !promo) return null;

  const handleButtonClick = () => {
    onClose();
    navigate(promo.buttonAction);
  };

  return (
    <div className="promo-modal-overlay" onClick={onClose}>
      <div className="promo-modal-content" onClick={e => e.stopPropagation()}>
        <button className="promo-close-btn" onClick={onClose}>✕</button>
        
        <div className="promo-modal-header" style={{ backgroundColor: promo.bgColor }}>
          <div className="promo-icon">{promo.icon}</div>
          <h1 className="promo-title" style={{ color: promo.textColor }}>{promo.title}</h1>
          <p className="promo-subtitle" style={{ color: promo.textColor }}>{promo.subtitle}</p>
        </div>

        <div className="promo-modal-body">
          <p className="promo-description">{promo.description}</p>
          
          <div className="promo-info-grid">
            <div className="promo-info-item">
              <span className="info-label">⏰ Timing:</span>
              <span className="info-value">{promo.timing}</span>
            </div>
            <div className="promo-info-item">
              <span className="info-label">👤 Age:</span>
              <span className="info-value">{promo.ageRestriction}</span>
            </div>
          </div>

          <div className="promo-offers">
            <h3>Today's Offers:</h3>
            <ul>
              {promo.offers.map((offer, idx) => (
                <li key={idx}>
                  <span className="offer-icon">✓</span>
                  {offer}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="promo-modal-footer">
          <button className="promo-btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
          <button 
            className="promo-btn-primary" 
            onClick={handleButtonClick}
            style={{ backgroundColor: promo.bgColor }}
          >
            {promo.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoModal;
